import ModelAnalytics from "./ModelAnalytics"
import ModelPhoto from "./ModelPhotos"

class ModelCheck {

/**
 * 
 * @param {ModelAnalytics} analytics 
 * @param {Array} analyticsWebview 
 * @param {string} brandName 
 * @param {string} categoryName 
 * @param {string} certificateCode 
 * @param {number} checkStatus 
 * @param {string} checkStatusName 
 * @param {string} checkBackgroundStatusName 
 * @param {number} backgroundNameFontSize 
 * @param {string} checkStatusClassName 
 * @param {string} checkStatusExplanation
 * @param {string} conditionName 
 * @param {string} countryName 
 * @param {string} date 
 * @param {number} id 
 * @param {ModelPhoto[]} photos 
 * @param {string} qrCode 
 * @param {string} styleCode 
 * @param {string} teamName 
 * @param {string} upcBarcode 
 * @param {string} userName 
 * @param {string} year 
 */
    constructor(
        analytics,
        analyticsWebview,
        brandName, 
        categoryName, 
        certificateCode, 
        checkStatus,
        checkStatusName,
        checkBackgroundStatusName,
        backgroundNameFontSize,
        checkStatusClassName,
        checkStatusExplanation,
        conditionName,
        countryName, 
        date, 
        id, 
        photos = [], 
        qrCode, 
        styleCode, 
        teamName, 
        upcBarcode, 
        userName, 
        year, 
    ) {
        this.analytics              = analytics                                                                                                               
        this.analyticsWebview       = analyticsWebview                                                                                                               
        this.brandName              = brandName                                                                                                                
        this.categoryName           = categoryName                                                                                                                
        this.certificateCode        = certificateCode                                                                                                                
        this.checkStatus            = checkStatus                                                                                                                
        this.checkStatusName        = checkStatusName                                                                                                                
        this.checkBackgroundStatusName      = checkBackgroundStatusName                                                                                                                
        this.backgroundNameFontSize         = backgroundNameFontSize                                                                                                                
        this.checkStatusExplanation         = checkStatusExplanation                                                                                                                
        this.checkStatusClassName       = checkStatusClassName                                                                                                                
        this.conditionName          = conditionName                                                                                                                
        this.countryName            = countryName                                                                                                                
        this.date                   = date                                                                                                                
        this.id                     = id                                                                                                                
        this.photos                 = photos                                                                                                                
        this.qrCode                 = qrCode                                                                                                                
        this.styleCode              = styleCode                                                                                                                
        this.teamName               = teamName                                                                                                                
        this.upcBarcode             = upcBarcode                                                                                                                
        this.userName               = userName                                                                                                                
        this.year                   = year                                                                                                                
    }

    fromJson(json) {
        console.log("json")
        console.log(json)
        // this.analytics          = new ModelAnalytics().fromJson(json.analytics)                                                                                                              
        this.analyticsWebview   = json.analyticsWebview ?? []                                                                                                            
        this.brandName          = json.brandName                                                                                                                
        this.categoryName       = json.categoryName                                                                                                                
        this.conditionName      = json.conditionName                                                                                                                
        this.countryName        = json.countryName                                                                                                                
        this.date               = json.date                                                                                                                
        this.id                 = json.id                                                                                                                
        this.qrCode             = json.qrCode                                                                                                                
        this.styleCode          = json.styleCode                                                                                                                
        this.certificateCode    = json.certificateCode 
        this.teamName           = json.teamName                                                                                                                
        this.upcBarcode         = json.upcBarcode                                                                                                                
        this.userName           = json.userName                                                                                                                
        this.year               = json.year 
        
        this.checkStatus        = json.checkStatus
        this.checkStatusName     = DEAFULT_STATUS.find(s => s.id === json.checkStatus).name
        this.checkBackgroundStatusName     = DEAFULT_STATUS.find(s => s.id === json.checkStatus).backgroundName
        this.checkStatusClassName     = DEAFULT_STATUS.find(s => s.id === json.checkStatus).className
        this.checkStatusExplanation     = DEAFULT_STATUS.find(s => s.id === json.checkStatus).explanation
        this.backgroundNameFontSize     = DEAFULT_STATUS.find(s => s.id === json.checkStatus).backgroundNameFontSize
        
        
        this.photos = []
        if (json.photos) {
            for (var i = 0; i < json.photos.length; i++) {
                const item = json.photos[i]
                this.photos.push(new ModelPhoto().fromJson(item))
            }
        }                                                                                                            

        return this
    }
}

export const DEAFULT_STATUS = [
    { id: 5, name: 'Counterfeit', className: "gradient-counterfeit", 
    backgroundName: "FAKE",    
    backgroundNameFontSize: 130,    
    explanation: "This item has been found not to comply with mandatory authenticity requirements and has been certified counterfeit."
    },
    
    { id: 15, name: 'Inconclusive', className: "gradient-inconclusive", 
    backgroundName: "INCONCLUSIVE",    
    backgroundNameFontSize: 65,    
    explanation: "Based on the imagery samples provided and Kitlegit’s own authenticity standards, this item has been rated as inconclusive."
    },
    
    { id: 25, name: 'Authentic', className: "gradient-authentic", 
    backgroundName: "LEGIT",    
    backgroundNameFontSize: 130,    
    explanation: "This item has been found to comply with mandatory authenticity requirements and has been certified authentic."
    },

    // this is "XSuspectedXX" but we show to the user as "Inconclusive"
    { id: 10, name: 'Inconclusive', className: "gradient-suspected", 
        backgroundName: "INCONCLUSIVE",    
        backgroundNameFontSize: 65,    
        explanation: "This item has been found to not to comply with some authenticity requirements and has been deemed suspected."
        },

        // this is "Likely Authentic" but we show to the user as "Inconclusive"
    { id: 20, name: 'Inconclusive', className: "gradient-likely", 
        backgroundName: "INCONCLUSIVE",    
        backgroundNameFontSize: 65,    
        explanation: "This item has been found to comply with most mandatory authenticity requirements and has been deemed likely authentic."
        },
]

export default ModelCheck

